import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { translate } from 'components/Translation';
import { Route, Switch } from 'react-router';
import ServicesList from './ServicesList';
import AddSingleService from './AddSingleService';
import React, { useState } from 'react';
import Confirmation from './subcomponents/Confirmation';
import { loadQualtrics } from 'utils/qualtrics';
interface IServicesProps {
	match: {
		path: string;
	};
	mainContainerRef?: React.RefObject<HTMLDivElement>;
}

const AddNewServices = ({ match, mainContainerRef }: IServicesProps) => {
	const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
	const [selectedNumber, setSelectedNumber] = useState<string>('');
	const [generatedSimDetails, setGeneratedSimDetails] = useState<types.newServices.ISimDetails | null>(null);
	const hideDialog = (): void => {
		setShowConfirmation(false);
		loadQualtrics({ activity_type: 'Add New Service - Mobile' });
	};

	const showConfirmationDialog = (number: string, simDetails?: types.newServices.ISimDetails) => {
		if (simDetails) {
			setGeneratedSimDetails(simDetails);
		} else {
			setGeneratedSimDetails(null);
		}
		setSelectedNumber(number);
		setShowConfirmation(true);
	};

	return (
		<>
			<BreadcrumbsItem to="/dashboard/services">{`${translate('path.my.services')} - ${translate(
				'path.new.services'
			)}`}</BreadcrumbsItem>
			<Switch>
				<Route path={match.path} exact render={(props: any) => <ServicesList {...props} />} />
				<Route
					path={`${match.path}/add/:accountId/:type`}
					render={(props: any) => (
						<AddSingleService
							showConfirmationDialog={showConfirmationDialog}
							{...props}
							mainContainerRef={mainContainerRef}
						/>
					)}
				/>
			</Switch>
			<Confirmation
				isOpen={showConfirmation}
				hideDialog={hideDialog}
				selectedNumber={selectedNumber}
				simDetails={generatedSimDetails}
			/>
		</>
	);
};

export default AddNewServices;
